<template>
  <div>
    <myHeader v-if="isShowHeader" :showHome="false" :showBack="true">
      <div slot="title">登录说明</div>
    </myHeader>
    <div class="login-desc-content">
      <div v-for="(item, index) in list" :key="index" class="desc-item">
        <div class="desc-title">{{ item.title }}</div>
        <div class="desc-content">
          <i></i>
          <div>{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from '@comp/header'
import setDocumentTitle from '@util/document-title'
export default {
  components: {
    myHeader,
  },
  data() {
    return {
      isShowHeader: true,
      list: [
        {
          title: '1、为什么要输入邀请码？',
          content: '当企业未录入员工手机号时，员工第一次登录，为校验您的身份，需输入邀请码，后续登录只需要凭手机号和验证码即可登录',
        },
        {
          title: '2、什么是邀请码？',
          content:
            '邀请码是系统为未录入手机号的员工自动成的、作为员工登录时的唯一身份标示，由公司统一下发给员工，邀请码在第一次登录成功后便作废，请妥善保管，不要告诉其他人，如您不知道您的邀请码，可联系公司相关负责人',
        },
      ],
    }
  },
  mounted() {
    setDocumentTitle('登录说明')
  },
}
</script>

<style lang="less" scoped>
.login-desc-content {
  margin-top: 60px;
  padding: 0 15px;
  font-size: 13px;
  color: #797d82;
  line-height: 20px;
  .desc-item {
    margin-bottom: 30px;
    .desc-content {
      display: flex;
      i {
        width: 3px;
        height: 3px;
        border-radius: 100%;
        background: #797d82;
        display: inline-block;
        margin-right: 5px;
        position: relative;
        top: 8px;
      }
      div {
        flex: 1;
        text-align: justify;
      }
    }
    .desc-title {
      color: #191a1b;
      font-size: 15px;
      margin-bottom: 4px;
    }
  }
}
</style>
